// NOTE: 공통 이미지
export const image = {
  // NOTE: images for all pages
  banner01: require("./assets/images/banner01.jpg"),
  headerProject01: require("./assets/images/headerProject01.png"),
  headerProject02: require("./assets/images/headerProject02.png"),
  headerProject03: require("./assets/images/headerProject03.png"),
  homeCampaign01: require("./assets/images/homeCampaign01.jpg"),
  homeCampaign02: require("./assets/images/homeCampaign02.jpg"),
  homeCampaign03: require("./assets/images/homeCampaign03.jpg"),
  homeCampaign04: require("./assets/images/homeCampaign04.jpg"),
  campaign01: require("./assets/images/campaign01.jpg"),
  campaign02: require("./assets/images/campaign02.jpg"),
  campaign03: require("./assets/images/campaign03.jpg"),
  latestActivities01: require("./assets/images/latestActivities01.jpg"),
  latestActivities02: require("./assets/images/latestActivities02.jpg"),
  balancedCoexistence: require("./assets/images/balancedCoexistence.jpg"),
  takeAction: require("./assets/images/takeAction.png"),
  declarationEstablishment: require("./assets/images/declarationEstablishment.png"),
  media01: require("./assets/images/media01.jpg"),
  media02: require("./assets/images/media02.jpg"),
  uniqueNumber: require("./assets/images/unique-number.png"),
  ourMemberThumbnail: require("./assets/images/our-member-thumbnail.jpeg"),
  changeEarthPoster: require("./assets/images/change-earth-poster.png"),
  changeEarthPoster2: require("./assets/images/change-earth-poster-2.jpeg"),
  campaignPoster01: require("./assets/images/65-poster01.jpeg"),
  campaignResult: require("./assets/images/65campaignResult.jpeg"),

  // NOTE: video
  videoThumbnail: require("./assets/images/video_thumbnail.png"),

  // NOTE: icons for all pages
  headerLogo: require("./assets/icons/headerLogo.svg"),
  footerLogo: require("./assets/icons/footerLogo.svg"),
  coreValue01: require("./assets/icons/coreValue01.svg"),
  coreValue02: require("./assets/icons/coreValue02.svg"),
  coreValue03: require("./assets/icons/coreValue03.svg"),
  heartIcon: require("./assets/icons/heartIcon.svg"),
  hamburgerIcon: require("./assets/icons/hamburgerIcon.svg"),
  userIcon: require("./assets/icons/userIcon.svg"),
  arrowIcon: require("./assets/icons/arrowIcon.svg"),
  closeIcon: require("./assets/icons/closeIcon.svg"),
  planetEarth: require("./assets/icons/planetEarth.svg"),
  action01: require("./assets/icons/action01.svg"),
  action02: require("./assets/icons/action02.svg"),
  action03: require("./assets/icons/action03.svg"),
  action04: require("./assets/icons/action04.svg"),
  action05: require("./assets/icons/action05.svg"),
  calendarIcon: require("./assets/icons/calendarIcon.svg"),
  rightArrowIcon: require("./assets/icons/rightArrowIcon.svg"),
  snsIcon01: require("./assets/icons/snsIcon01.svg"),
  snsIcon02: require("./assets/icons/snsIcon02.svg"),
  snsIcon03: require("./assets/icons/snsIcon03.svg"),
  snsIcon04: require("./assets/icons/snsIcon04.svg"),
  videoPlayButton: require("./assets/icons/videoPlayButton.svg"),
  paginationArrow: require("./assets/icons/paginationArrow.svg"),
  paginationArrowDisabled: require("./assets/icons/paginationArrowDisabled.svg"),
  activityIcon01: require("./assets/icons/activityIcon01.svg"),
  activityIcon02: require("./assets/icons/activityIcon02.svg"),
  activityIcon03: require("./assets/icons/activityIcon03.svg"),
  reportIcon01: require("./assets/icons/reportIcon01.svg"),
  reportIcon02: require("./assets/icons/reportIcon02.svg"),
  rightArrowGreen: require("./assets/icons/rightArrowGreen.svg"),
  rightArrowOrange: require("./assets/icons/rightArrowOrange.svg"),
  googleIcon: require("./assets/icons/google-logo.svg"),
  kakaoIcon: require("./assets/icons/kakao-logo.svg"),
  loadingIcon: require("./assets/icons/loading.svg"),
};

// NOTE: 공통 컬러
export const color = {
  primary01: "#90B870",
  primary02: "#609933",
  secondary01: "#FF8D56",
  secondary02: "#FF6000",
  tertiary: "#F90C5E",
  tertiary02: "rgba(249,12,94, 0.3)",
  error: "#ff4d4f",
  blue01: "#6DA1D8",
  black01: "#000",
  black02: "#2F2F2F",
  pink: "#F7D8E2",
  grey01: "#595959",
  grey02: "#444444",
  grey03: "#E5E5E5",
  grey04: "#CCCCCC",
  grey05: "#B2B2B2",
  grey06: "#777777",
  peach: "#FFF3EB",
};

export const AppTheme = {
  image,
  color,
  fontFamily: {
    // NOTE: 공통 폰트 스타일
    primary: "'Gmarket-Sans', sans-serif",
    secondary: "'Noto Sans KR', sans-serif",
  },
  fontWeight: {
    // NOTE: 공통 폰트 굵기
    light: 300,
    regular: 500,
    bold: 600,
  },
  shadow: {},
  radius: {},
};

export default AppTheme;
